
export default {
  props: {
    DATA: Object,
  },
};
